//
//
//
//
//
//
//
//
//
//
//
//
//

import FaqListItem from '../vue/FaqListItem.vue';

export default {
	data() {
		return {
			window: {
				width: 0,
				height: 0,
			},
		};
	},

	props: {
		title: {},
		faqs: {},
	},

	computed: {},

	watch: {},

	methods: {
		handleResize() {
			this.window.width = window.innerWidth;
			this.window.height = window.innerHeight;
		},
	},

	components: {
		FaqListItem,
	},

	created() {
		window.addEventListener('load', this.handleResize);
		window.addEventListener('resize', this.handleResize);
	},
	destroyed() {},
	mounted() {},
};



// WEBPACK FOOTER //
// ./scripts/vue/FaqList.vue